export default __webpack_public_path__ + "static/media/tcl.ef30ddf5.png";